/**
 * STOP USING ME OKAY?! If you need to connect to BE use /lib/api.ts instead 😘
 */

import Api, { APIDomain } from "@secondcloset/api-utils";

import axios, { AxiosRequestConfig } from "axios";

import BASE_URL, { BFAPI_URL, NOVEMBER_URL } from "../config/baseURL";

import Cookies from "./Cookies";

export default class API extends Api {
  constructor(domain?: APIDomain, settings = {}) {
    const USER_TOKEN = Cookies.getUserToken();
    const getBaseUrl = (domain?: APIDomain) => {
      if (domain === "bfapi") return BFAPI_URL;
      if (domain === "november") return NOVEMBER_URL;
      return String(BASE_URL).replace("/api/v1", "");
    };
    const baseURL = getBaseUrl(domain);
    super({ baseURL, domain, token: USER_TOKEN, ...settings });
  }

  get(url: string) {
    return super.get(url).catch((e) => {
      throw e;
    });
  }

  delete(url: string) {
    return super.delete(url).catch((e) => {
      throw e;
    });
  }

  put(url: string, body?: any) {
    return super.put(url, body).catch((e) => {
      throw e;
    });
  }

  post(url: string, body?: any) {
    return super.post(url, body).catch((error) => {
      throw error;
    });
  }

  buildQueryString(option: { [key: string]: any }) {
    if (!option || Object.keys(option).length === 0) return "";

    const keyEqualsValue = Object.keys(option).map((key) => `${key}=${option[key]}`);

    return `?${keyEqualsValue.join("&")}`;
  }

  getPDFHeader() {
    const USER_TOKEN = Cookies.getUserToken();
    return {
      headers: {
        "Content-Type": "application/pdf",
        Authorization: "Bearer ".concat(USER_TOKEN),
      },
      responseType: "blob",
    } as AxiosRequestConfig;
  }

  getFileHeader() {
    const USER_TOKEN = Cookies.getUserToken();
    return {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer ".concat(USER_TOKEN),
      },
    } as AxiosRequestConfig;
  }

  getPDF(url: string) {
    return axios.get(this.baseUrl + url, this.getPDFHeader()).catch((e) => {
      throw e;
    });
  }

  getPickSheetsPDF(url: string, shipmentIds: string[], version: 1 | 2) {
    const body = version === 1 ? { shipment_numbers: shipmentIds } : { shipment_ids: shipmentIds };
    const config = this.getPDFHeader();
    if (config.headers) config.headers["Content-Type"] = "application/json"; //overide to /json since request is sending json body on post method
    return axios.post(this.baseUrl + url, body, config).catch((e) => {
      throw typeof e === "string" ? e : e.message;
    });
  }
}
